import React from 'react';
import Button from 'chameleon/ui-stack/ui/base/button';

const ProgressIcon = ({ isPerformance }) => {
  const title = isPerformance ? 'View All' : 'View Progress';
  return (
    <Button
      isPrimary
      className=""
      tabIndex={0}
      accessibility={{ 'aria-label': title }}
    >
      {title}
    </Button>
  );
};

export default ProgressIcon;
